// extracted by mini-css-extract-plugin
export var formContainer = "_hu-0";
export var message = "_hu-1";